import { useEmblaCarousel } from 'embla-carousel/react'
import { useState } from 'react'

function useGallery() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const [viewport, slider] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    selectedClass: '',
    dragFree: true,
    skipSnaps: true,
    align: 'start',
  })

  const changeSlide = (index: number) => {
    if (!slider) return
    slider.scrollTo(index - 1)
    setCurrentSlide(index)
  }

  return { viewport, changeSlide, currentSlide }
}

export default useGallery
